import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  footer: theme => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.neutral[200]};
    width: 100%;
    z-index: 9;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      text-align: center;
      flex-direction: column;
    }
  `,
  suportLink: theme => css`
    margin-left: ${theme.spacing.xxs};
  `,
})

export default useStyles
